"use strict";

export default angular.module("contartemx.administracion.cuentas")
  .controller("InvitarColaboradorCtrl", ($scope, $state, $stateParams, $uibModalInstance, apiCall, roles, mostrarNotificacion, ServicioValidacion, ServicioChargebee) => {

    const ContarteAPI = new apiCall($scope);

        $scope.loading = false;

        $scope.RE_CORREO = ServicioValidacion.RE_CORREO;

        $scope.colaborador = {};
        $scope.grupoPermisos = {};

        $scope.cambiarPermisos = () => {
            let permisosColaborador = $scope.roles.find(r => r.CveTipoUsuario == $scope.colaborador.rol);

            if (permisosColaborador && angular.isArray(permisosColaborador.Permisos)) {
                $scope.grupoPermisos['Administración'] = permisosColaborador.Permisos.filter(p => p.CvePermiso > 0 && p.CvePermiso < 10000);
                $scope.grupoPermisos['Preferencias'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 10000 && p.CvePermiso < 20000);
                $scope.grupoPermisos['Clientes'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 20000 && p.CvePermiso < 30000);
                $scope.grupoPermisos['Proveedores'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 30000 && p.CvePermiso < 40000);
                $scope.grupoPermisos['Personal'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 40000 && p.CvePermiso < 50000);
                $scope.grupoPermisos['Bancos'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 50000 && p.CvePermiso < 60000);
                $scope.grupoPermisos['Reportes'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 60000 && p.CvePermiso < 70000);
                $scope.grupoPermisos['Contabilidad'] = permisosColaborador.Permisos.filter(p => p.CvePermiso >= 70000 && p.CvePermiso < 80000);
            }
        };

        $scope.reiniciarRoles = () => {
            $scope.colaborador.permisosPersonalizados = false;
            $scope.roles = JSON.parse(JSON.stringify({ roles })).roles;
            $scope.cambiarPermisos();
        };

        $scope.reiniciarRoles();

        $scope.closeModal = (respuesta) => {
            $uibModalInstance.dismiss();
        };

        $scope.invitarColaborador = () => {
    
            $scope.loading = true;

            let colaborador = $scope.colaborador,
                rol = $scope.roles.find(r => r.CveTipoUsuario == $scope.colaborador.rol),
                datos = {
                    CveContribuyente: $stateParams.cveContribuyente,
                    Correo: colaborador.correo,
                    CveTipoUsuario: colaborador.rol,
                    Permisos: rol ? rol.Permisos : null,
                };


            apiCall.post("InvitarColaborador", datos)
                .then((data) => {
                    if (data.EsError) {
                        $scope.alert = [{ msg: data.Mensaje }];
                    } else {
                      $uibModalInstance.close(data);
                      $state.reload();
                    }
                },
                mostrarNotificacion.error)
                .finally(() => $scope.loading = false);

        };

        $scope.cambioPermiso = (permiso, checkbox) => {

            $scope.colaborador.permisosPersonalizados = true;

            switch (checkbox) {
                case 'R':
                    permiso.ConEscritura = permiso.EstaActivo && permiso.ConEscritura;
                    break;
                case 'W':
                    permiso.EstaActivo = permiso.EstaActivo || permiso.ConEscritura;
                    break;
                default: break;
            }

        };

        $scope.closeModalAlert = index => {
            $scope.alert.splice(index, 1);
        };

        $scope.numeroPermisos = key => {
            let permisos = $scope.grupoPermisos[key];
            if (angular.isArray(permisos)) {
                return `${permisos.filter(p => p.EstaActivo).length}/${permisos.length}`;
            }

        };

        $scope.mostrarPermisos = key => {
            let isOpen = $scope.grupoPermisos[key].isOpen;
            for (let prop in $scope.grupoPermisos) {
                $scope.grupoPermisos[prop].isOpen = false;
            }
            $scope.grupoPermisos[key].isOpen = !isOpen;
    };

    $scope.ActualizarAddons = () => {

      ContarteAPI.post("ObtenerSuscripcionActual", { tipo: "CONTRIBUYENTE", clave: $stateParams.cveContribuyente })
        .then((res) => {
          if (res.EsError) {
            mostrarNotificacion.error("Hubo un error al mandar la petición");
          } else {
            ServicioChargebee.editarSuscription(res.Respuesta.Id);
          }
        }, (error) => {
          mostrarNotificacion.error("Hubo un error al mandar la petición.");
        });

    };

    });
